import React, { Component } from 'react';
import Button from '../Button';
import './SingleSelectSubHeader.scss';

class SingleSelectSubHeader extends Component {
  static defaultProps = {
    variant: 'default'
  }
  render() {
    const {
     t,
     onApplyFilter,
     languages,
     selectedLanguage,
     isRtl,
     books
    } =this.props;

    const baseClassName = "pb-single-select-sub-header";

    return (
        <div className={isRtl ? `${baseClassName} ${baseClassName}--rtl` : `${baseClassName}`}>
          <span className={`${baseClassName}__text`}>{t("global.reading-program-select-language")} :</span>
          {
            languages.map(item=>{
                return <Button rounded variant={selectedLanguage === item.queryValue ? "light-selected" : "light"} parentClassName={`${baseClassName}__btn`} label={item.name} onClick={()=>onApplyFilter('language', item.queryValue)} count={books && books.filter(book=>book.locale === item.queryValue) && books.filter(book=>book.locale === item.queryValue).length} isRtl={isRtl}/>
            })
          }
        </div>
    );
  }
}

SingleSelectSubHeader.propTypes = {

};

export default SingleSelectSubHeader;



// WEBPACK FOOTER //
// ./src/components/SingleSelectSubHeader/SingleSelectSubHeader.jsx